module.exports = __webpack_public_path__ + "static/media/sports_33.04318185.jpg";